import {
  SELECT_TAB
} from "./nav-types";

export const selectTab = (tab: string) => ({
  type: SELECT_TAB,
  payload: tab,
});